import {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Formik} from 'formik';
import * as Yup from 'yup';
import MobilePopup from '../../../../../../component/newPopup/mobilePopup/MobilePopup';
import {TShow} from '../../../../../../component/prompotionPopup/PromotionPopup';
import {yupStringMin} from '../../../../../../functions/validationsYup';
import * as css from './CreateEventPopup.css';
import CreateEventPopupFooter from './CreateEventPopupFooter';
import CreateEventPopupForm from './CreateEventPopupForm';
import {useEventTypesList} from './useEventTypesList';
import {useCreateEventSubmit} from './useCreateEventSubmit';

function CreateEventPopup({show}: {show: TShow}) {
    const {t} = useTranslation('subscriptions');
    const formRef = useRef(null);
    const eventTypesList = useEventTypesList();
    const [submitAction, setSubmitAction] = useState<'saveAndGoToSettings' | 'saveDraft' | null>(null);
    const {handleSubmit} = useCreateEventSubmit({onClose: show.close, submitAction});

    const initialValues = {
        eventName: '',
        eventType: ''
    };

    const validationSchema = Yup.object().shape({
        eventName: yupStringMin().required(t('pleaseEnterEventTitle')),
        eventType: Yup.string().required(t('pleaseSelectEventType'))
    });

    return (
        <MobilePopup 
            showClass={show.showClass || ''}
            close={show.close}
            title={t('createNewEvent')}
            dataCyName="createEventPopup"
            list={undefined}
            forwardRef={undefined}
            height={'400px'}
            TopComponent={null}
        >
            <Formik
                innerRef={formRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({submitForm}) => {
                    // const handleSaveAndGoToSettingsClick = () => {
                    //     setSubmitAction('saveAndGoToSettings');
                    //     submitForm();
                    // };
                    const handleSaveDraftClick = () => {
                        setSubmitAction('saveDraft');
                        submitForm();
                    };

                    return (
                        <>
                            <css.header />
                            <css.container>
                                <CreateEventPopupForm eventTypesList={eventTypesList} />
                                <CreateEventPopupFooter
                                    onCancel={() => show.close()}
                                    onSaveDraft={handleSaveDraftClick}
                                    // onSaveAndGoToSettings={handleSaveAndGoToSettingsClick}
                                />
                            </css.container>
                        </>
                    );
                }}
            </Formik>
        </MobilePopup>
    );
}

export default CreateEventPopup;
